import { ListenEvent } from '../app/Globals/index';
import { UrlSegments } from '../app/Helpers/index';
import { WaitForElementToDisplay } from '../app/Helpers/WaitForElementToDisplay';
import { ICartVM } from '../global';

export const MyAccountRoutes = new Promise(() => {
    if (UrlSegments()[0] === "MyAccount") {
        console.info("Navigated to MyAccount section");
        let Listener = ListenEvent;
        Listener.activeMyAccountNavTab();

        let view = UrlSegments()[1];

        if (view === "AccountUsers") {
            import('../app/ViewModels/MyAccount/AccountUsers' /* webpackChunkName: "account-users" */).then((viewModel) => {
                console.info("Init AccountUsers VM...");
                let vm = new viewModel.AccountUsersVM();
                window.vm = vm;

                if (window.UserMeta.UserRoleRecNo < 3) {
                    import('../app/Components/GridViewFilterHide' /* webpackChunkName: "grid-filter-hide" */).then((HideFilter) => {
                        HideFilter.GridViewFilterHide();
                    });
                }

                WaitForElementToDisplay("#account-users", 300, () => {
                    ko.applyBindings(vm, document.getElementById("account-users"))
                });
                console.info("AccountUsers VM bound");
            })
        }

        if (view === "AccountSettings") {
            import('../app/ViewModels/MyAccount/AccountSettings' /* webpackChunkName: "account-settings" */).then((viewModel) => {
                console.info("Init AccountSettings VM...");
                let vm = new viewModel.AccountSettingsVM(window.Model);
                window.vm = vm;

                WaitForElementToDisplay("#account-settings", 300, () => {
                    ko.applyBindings(vm, document.getElementById('account-settings'))
                });
                console.info("AccountSettings VM bound");
            })
        }

        if (view === "Addresses") {
            import('../app/ViewModels/MyAccount/Addresses' /* webpackChunkName: "addresses" */).then((viewModel) => {
                console.info("Init Addresses VM...");
                let Model = window.Model;
                let vm = new viewModel.AddressesVM(Model.ShipDataSource, Model.BillDataSource, Model.CustomerNo, Model.AcctRecNo);
                window.vm = vm;
                (<any>vm).RoleRecNo = window.UserMeta.UserRoleRecNo;

                $(function () {

                    ko.validation.init({
                        registerExtenders: true,
                        decorateInputElement: true,
                        parseInputAttributes: true,
                        writeInputAttributes: true,
                        errorElementClass: 'is-invalid',
                        errorMessageClass: 'invalid-tooltip',

                        insertMessages: true,
                        messagesOnModified: false,
                        messageTemplate: null,
                        grouping: { live: true }
                    }, true);

                    WaitForElementToDisplay("#ship-bill-addresses", 300, () => {
                        ko.applyBindings(vm, document.getElementById('ship-bill-addresses'))
                    });

                    let init = true;
                    $(document).ajaxStop(function () {
                        if (Model.RoleRecNo < 3 && init)
                            import('../app/Components/GridViewFilterHide' /* webpackChunkName: "grid-filter-hide" */).then((HideFilter) => {
                                HideFilter.GridViewFilterHide();
                                init = false;
                            });
                    })
                });
            });
        }

        if (view === "UserContacts") {
            import('../app/ViewModels/MyAccount/UserContacts' /* webpackChunkName: "user-contacts" */).then((viewModel) => {
                console.info("Init UserContacts VM...");
                let Model = window.Model;
                let ViewModel = new viewModel.UserContactsVM(Model.AcctRecNo, Model.RoleRecNo, Model.AccountsList)
                var vm = ko.validatedObservable(ViewModel)();
                window.vm = vm;

                WaitForElementToDisplay("#user-contacts", 300, () => {
                    ko.applyBindings(vm, document.getElementById('user-contacts'))
                });

                $(document).ajaxStop(function () {
                    if (Model.RoleRecNo < 3) {
                        import('../app/Components/GridViewFilterHide' /* webpackChunkName: "grid-filter-hide" */).then((HideFilter) => {
                            HideFilter.GridViewFilterHide();
                        });
                    }
                })
            });
        }        

        if (view === "UserImpersonation") {
            import('../app/ViewModels/MyAccount/UserImpersonation' /* webpackChunkName: "user-impersonation" */).then((viewModel) => {
                console.info("Init UserImpersonation VM...");
                let vm = new viewModel.UserImpersonationVM();
                window.vm = vm;

                WaitForElementToDisplay("#user-impersonation-list", 300, () => {
                    ko.applyBindings(vm, document.getElementById('user-impersonation-list'))
                });
            });
        }

        if (view === "CartsSaved") {
            // Redirect if we accidentally get here (mostly during development)
            if (window.location.href === "/MyAccount/CartsSaved/" || window.location.href === "/MyAccount/CartsSaved/Index") {
                return window.location.href = "/MyAccount/CartsSaved";
            }

            let InitSavedCarts = ((cartViewModel: ICartVM) => {
                import('../app/ViewModels/MyAccount/SavedCarts' /* webpackChunkName: "saved-carts" */).then((viewModel) => {
                    console.info("Initialize SavedCarts VM...");
                    let vm = new viewModel.SavedCarts();
                    window.vm = vm;

                    window.cartVM.savedCarts = vm;

                    WaitForElementToDisplay("#saved-carts", 300, () => {
                        ko.applyBindings(vm, document.getElementById('saved-carts'))
                    });

                    console.info("SavedCarts VM bound: ");
                }).then(() => {

                })
            });

            import('../routes' /* webpackChunkName: "saved-carts" */).then((router) => {
                ListenEvent.WaitForCartVM.then((cartVM: ICartVM) => {
                    InitSavedCarts(cartVM);
                })
            });
        }

        if (view === "CartsSubmitted") {

            import('../app/ViewModels/MyAccount/CartsSubmitted' /* webpackChunkName: "carts-submitted" */).then((viewModel) => {
                console.info("Init CartsSubmitted VM...");
                let Model = window.Model;

                let UserRoleRecNo = window.UserMeta.UserRoleRecNo;

                var vm = new viewModel.CartSubmittedVM(Model, UserRoleRecNo);
                window.vm = vm;

                $(() => {
                    let init = true;

                    $(document).ajaxStop(function () {
                        if (UserRoleRecNo < 3 && init) {
                            import('../app/Components/GridViewFilterHide' /* webpackChunkName: "grid-filter-hide" */).then((HideFilter) => {
                                HideFilter.GridViewFilterHide();
                                init = false;
                            });
                        }
                    })

                    WaitForElementToDisplay("#carts-submitted-list", 300, () => {
                        ko.applyBindings(vm, document.getElementById('carts-submitted-list'))
                    });

                    console.info("CartsSubmitted VM bound")
                });
            });
        }

        if (view === "ReceivingReports") {
            import('../app/ViewModels/MyAccount/ReceivingReports' /* webpackChunkName: "receiving-reports" */).then((viewModel) => {
                console.info("Init ReceivingReports VM...");

                let vm = ko.validatedObservable(new viewModel.ReceivingReportsViewModel())();
                window.vm = vm;

                WaitForElementToDisplay("#receiving-reports", 300, () => {
                    ko.applyBindings(vm, document.getElementById('receiving-reports'))
                });

                let init = true;
                $(document).ajaxStop(function () {
                    if (window.UserMeta.UserRoleRecNo < 1 && init)
                        import('../app/Components/GridViewFilterHide' /* webpackChunkName: "grid-filter-hide" */).then((HideFilter) => {
                            HideFilter.GridViewFilterHide();
                            init = false;
                        });
                })
            });
        }

        if (view === "BackorderStatus") {
            import('../app/ViewModels/MyAccount/BackorderStatus' /* webpackChunkName: "backorder-status" */).then((viewModel) => {
                console.info("Init BackorderStatus VM...");
                let vm = new viewModel.BackorderStatusVM()
                window.vm = vm;
                WaitForElementToDisplay("#backorder-status-list", 300, () => {
                    ko.applyBindings(vm, document.getElementById('backorder-status-list'))
                });
            });
        }

        if (view === "BackorderPriority") {
            import('../app/ViewModels/MyAccount/BackorderPriority' /* webpackChunkName: "backorder-priority" */).then((viewModel) => {
                console.info("Init BackorderPriority VM...");
                let vm = new viewModel.BackorderPriorityVM()
                window.vm = vm;

                WaitForElementToDisplay("#backorder-priority-list", 300, () => {
                    ko.applyBindings(vm, document.getElementById('backorder-priority-list'))
                });
            });
        }

        if (view === "Allocations") {           
                 function InitVM() {
                     console.group("Initializing ItemList VM...")
                     import('../app/ViewModels/Products/ItemList' /* webpackChunkName: "item-list" */).then((viewModel) => {
                         (<any>window).DataLoaded = ko.observable(false);

                         let Model = window.Model;
                         let vm = new viewModel.ItemList(Model.SupplyLists, Model.ParamID);
                         window.vm = vm;

                         WaitForElementToDisplay("#item-list", 300, () => {
                             ko.applyBindings(vm, document.getElementById('item-list'))
                         });                         
                     });
                 }
                 ListenEvent.WaitForCartVM.then(() => {
                     InitVM();
                 })             
        }

        if (view === "SupplyListAdmin") {
            import('../app/ViewModels/MyAccount/SupplyListAdmin' /* webpackChunkName: "supply-list-admin" */).then((viewModel) => {
                console.info("Init SupplyListAdmin VM...");
                let DataSource = ko.observable(window.Model),
                    vm = new viewModel.SupplyListAdminVM(DataSource, window.UserMeta.UserRoleRecNo);
                window.vm = vm;

                WaitForElementToDisplay("#supply-list-admin", 300, () => {
                    ko.applyBindings(vm, document.getElementById('supply-list-admin'))
                });

                $('#userImpersonationList-searchInput').focus();
                console.info("SupplyListAdmin VM bound: ");
            });
        }

        if (view === "SupplyListUsers") {
            import('../app/ViewModels/MyAccount/SupplyListUsers' /* webpackChunkName: "supply-list-users" */).then((viewModel) => {
                console.info("Init SupplyListUsers VM...");
                let Model = window.Model;
                let vm = new viewModel.SupplyListUsers(Model);
                window.vm = vm;

                WaitForElementToDisplay("#supply-list-users", 300, () => {
                    ko.applyBindings(vm, document.getElementById('supply-list-users'))
                });

                console.info("SupplyListUsers VM bound: ");
            });
        }

        if (view === "InvoiceHistory") {
            import('../app/ViewModels/MyAccount/InvoiceHistory' /* webpackChunkName: "invoice-history" */).then((viewModel) => {
                console.info("Init InvoiceHistory VM...");
                let vm = new viewModel.InvoiceHistoryViewModel()
                window.vm = vm;

                WaitForElementToDisplay("#invoice-history", 300, () => {
                    ko.applyBindings(vm, document.getElementById('invoice-history'))
                });

                WaitForElementToDisplay("#invoice-history-range", 300, () => {
                    ko.applyBindings((<any>vm).InvoiceHistoryRange, document.getElementById('invoice-history-range'))
                });
            });
        }

        if (view === "ItemHistory") {
            import('../app/ViewModels/MyAccount/ItemHistory' /* webpackChunkName: "item-history" */).then((viewModel) => {
                console.info("Init ItemHistory VM...");
                let vm = new viewModel.ItemHistoryVM()
                window.vm = vm;

                $(() => {
                    WaitForElementToDisplay("#item-history", 300, () => {
                        ko.applyBindings(vm, document.getElementById('item-history'))
                    });

                    WaitForElementToDisplay("#item-history-range", 300, () => {
                        ko.applyBindings((<any>vm).ItemHistoryRange, document.getElementById('item-history-range'))
                    });
                })
            });
        }

        if (view === "DrugSupplyChainPortal") {
            import('../app/ViewModels/MyAccount/DrugSupplyChainPortal' /* webpackChunkName: "drug-supply-chain" */).then((viewModel) => {
                console.info("Init DrugSupplyChainPortal VM...");
                let vm = new viewModel.DrugSupplyChainVM()
                window.vm = vm;

                $(() => {
                    WaitForElementToDisplay("#drug-supply-chain-grid", 300, () => {
                        ko.applyBindings(vm, document.getElementById('drug-supply-chain-grid'))
                    });
                })
                
            });
        }
    }
});